import { render, staticRenderFns } from "./PmseLayout.vue?vue&type=template&id=0d8c990a"
import script from "./PmseLayout.vue?vue&type=script&lang=js"
export * from "./PmseLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports